// components/AdminLayout.jsx

import React, { useState } from 'react';
import styles from '../styles/AdminDashboard.module.css';
import ReservationsPanel from './admin/ReservationsPanel';
import MenuPanel from "./admin/MenuPanel";

export default function AdminLayout() {

    const [activeTab, setActiveTab] = useState('reservations');

    const logout = () => {
        localStorage.removeItem('token');
        window.location.href = '/admin/login';
    };

    return (
        <div className={styles.dashboard}>

            {/* HEADER */}
            <div className={styles.adminHeader}>
                <h1 className={styles.title}>Admin Panel</h1>

                <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                        onClick={() => setActiveTab('reservations')}
                    >
                        Reservations
                    </button>

                    <button
                        onClick={() => setActiveTab('menu')}
                    >
                        Menu
                    </button>

                    <button onClick={logout}>
                        Logout
                    </button>
                </div>
            </div>

            {/* CONTENT AREA */}
            <div className={styles.adminContent}>

                {activeTab === 'reservations' && (
                    <ReservationsPanel />
                )}

                {activeTab === 'menu' && (
                    <MenuPanel />
                )}

            </div>

        </div>
    );
}